import axios from 'axios';
import store from 'store';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Public instance for unauthenticated requests
const publicInstance = axios.create({
  baseURL: axiosInstance.defaults.baseURL,
  headers: { 'Content-Type': 'application/json' },
});
const imageInstance = axios.create({
  baseURL: axiosInstance.defaults.baseURL,
  headers: { 'Content-Type': 'multipart/form-data' },
});

const publicImageInstance = axios.create({
  baseURL: axiosInstance.defaults.baseURL,
  headers: { 'Content-Type': 'multipart/form-data' },
});
// Private instance for authenticated requests
const privateInstance = axios.create({
  baseURL: axiosInstance.defaults.baseURL,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
});

// Add Authorization header to private requests
privateInstance.interceptors.request.use(
  (config) => {
    const state = store.getState();
    const token = state.auth.accessToken; // Get the token from Redux state

    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
imageInstance.interceptors.request.use(
  (config) => {
    const state = store.getState();
    const token = state.auth.accessToken; // Get the token from Redux state

    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// Add response interceptors for error handling
interface AxiosErrorResponse {
  response?: {
    status: number;
  };
}

const handleErrorResponse = (error: AxiosErrorResponse): Promise<never> => {
  if (error.response && error.response.status === 401) {
    const token = localStorage.getItem('accessToken');
    if (token) {
      // Todo: Remove access token and user from ls
      localStorage.clear();
      // Redirect to login
      window.location.href = '/auth/login';
    }
  }
  return Promise.reject(error);
};

privateInstance.interceptors.response.use(
  (response) => response,
  handleErrorResponse
);

export default {
  public: publicInstance,
  private: privateInstance,
  image: imageInstance,
  publicImage: publicImageInstance,
};
